module.exports = __webpack_public_path__ + "img/how2.7a065f61.svg";